// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#works {
    margin: 0 auto;
    min-height: calc(100vh - 4rem);
    width: 100vw;
    max-width: 60rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 1rem;
}

.project-link h3 svg {
    margin-left: 10px;
    vertical-align: middle;
    color: #007bff;
}

/* Projects.css */
.projects-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
}

.projects-list {
    list-style: none;
    padding: 0;
}

.project-item {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    transition: transform 0.2s, box-shadow 0.2s;
}

.project-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.project-link {
    text-decoration: none;
    color: inherit;
    display: block;
    padding: 20px;
}

.project-link h3 {
    margin: 0 0 10px;
    font-size: 1.5rem;
    color: whitesmoke;
}

.project-link p {
    margin: 0;
    font-size: 1rem;
    color: #666;
}

/*.worksTitle {*/
/*    margin: 1rem 0;*/
/*    font-size: 3rem;*/
/*}*/

.worksDesc {
    font-weight: 300;
    font-size: 1rem;
    max-width: 45rem;
    margin-bottom: 12px;
}

/*.worksImgs {*/
/*    display: flex;*/
/*    align-items: center;*/
/*    justify-content: center;*/
/*    flex-wrap: wrap;*/
/*    width: 100vw;*/
/*    max-width: 65rem;*/
/*}*/

/*.worksImg {*/
/*    object-fit: cover;*/
/*    height: 20rem;*/
/*    margin: 0.5rem;*/
/*}*/

/*.workBtn {*/
/*    margin: 3rem 0;*/
/*    padding: 0.5rem 2.5rem;*/
/*    border: none;*/
/*    border-radius: 2rem;*/
/*    background: white;*/
/*    font-size: 1rem;*/
/*}*/

@media screen and (max-width:585px) {
    .worksImg {
        height: 48vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Works/works.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA,gBAAgB;AAChB,sBAAsB;AACtB,uBAAuB;AACvB,IAAI;;AAEJ;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,eAAe;AACf,qBAAqB;AACrB,2BAA2B;AAC3B,+BAA+B;AAC/B,uBAAuB;AACvB,oBAAoB;AACpB,wBAAwB;AACxB,IAAI;;AAEJ,cAAc;AACd,yBAAyB;AACzB,qBAAqB;AACrB,sBAAsB;AACtB,IAAI;;AAEJ,aAAa;AACb,sBAAsB;AACtB,8BAA8B;AAC9B,oBAAoB;AACpB,2BAA2B;AAC3B,yBAAyB;AACzB,uBAAuB;AACvB,IAAI;;AAEJ;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["#works {\n    margin: 0 auto;\n    min-height: calc(100vh - 4rem);\n    width: 100vw;\n    max-width: 60rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 0 1rem;\n}\n\n.project-link h3 svg {\n    margin-left: 10px;\n    vertical-align: middle;\n    color: #007bff;\n}\n\n/* Projects.css */\n.projects-container {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n}\n\n.projects-list {\n    list-style: none;\n    padding: 0;\n}\n\n.project-item {\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.project-item:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.project-link {\n    text-decoration: none;\n    color: inherit;\n    display: block;\n    padding: 20px;\n}\n\n.project-link h3 {\n    margin: 0 0 10px;\n    font-size: 1.5rem;\n    color: whitesmoke;\n}\n\n.project-link p {\n    margin: 0;\n    font-size: 1rem;\n    color: #666;\n}\n\n/*.worksTitle {*/\n/*    margin: 1rem 0;*/\n/*    font-size: 3rem;*/\n/*}*/\n\n.worksDesc {\n    font-weight: 300;\n    font-size: 1rem;\n    max-width: 45rem;\n    margin-bottom: 12px;\n}\n\n/*.worksImgs {*/\n/*    display: flex;*/\n/*    align-items: center;*/\n/*    justify-content: center;*/\n/*    flex-wrap: wrap;*/\n/*    width: 100vw;*/\n/*    max-width: 65rem;*/\n/*}*/\n\n/*.worksImg {*/\n/*    object-fit: cover;*/\n/*    height: 20rem;*/\n/*    margin: 0.5rem;*/\n/*}*/\n\n/*.workBtn {*/\n/*    margin: 3rem 0;*/\n/*    padding: 0.5rem 2.5rem;*/\n/*    border: none;*/\n/*    border-radius: 2rem;*/\n/*    background: white;*/\n/*    font-size: 1rem;*/\n/*}*/\n\n@media screen and (max-width:585px) {\n    .worksImg {\n        height: 48vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
